import { LAB_REPORT } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";
import { ITRFUpdatePayload, TRFUpdateResponse } from "@/api_framework/api_modals/LabReport";

AxiosCurlirize(axios, () => {});
export const useTRFUpdateAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (requisition_id: string, body: ITRFUpdatePayload, _actionType?: string | null) => {
      dispatch(
        setLoading({
          key: "isEMRUpdateInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response: TRFUpdateResponse = await axios.post(`${LAB_REPORT?.TRF_UPDATE?.baseURL}`, body, {
            params: {
              requisition_id: requisition_id,
            },

            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );
            if (res.data.status) {
              return { status: true, message: res.data.data, data: res.data.data };
            } else {
              return { status: false, message: null, data: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isEMRUpdateInProgress",
                status: false,
              }),
            );
            if (e.response?.status === 500) {
              toast.error("500 Server Error, Contact Tech Team.");
            }
            captureError(e);
            return { status: false, message: null, data: null };
          });
        return response;
      } catch (e: any) {
        if (e.response?.status === 500) {
          toast.error("500 Server Error, Contact Tech Team.");
        }
        dispatch(
          setLoading({
            key: "isEMRUpdateInProgress",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return execute;
};
